<template>
    <widget-card
        title="Encounters by day & status"
        :loading="loading"
        :error="error"
        :empty="!loading && (!payload || payload.byDay.length === 0)"
        :hidden="hidden"
        @retry="fetchData"
    >
        <div class="enc-wrap" :class="{ 'is-dark': $vuetify.theme.dark }">
        <table v-if="payload && payload.byDay.length" class="enc-table">
            <thead>
                <tr>
                    <th>Day</th><th>Status mix</th><th>Edit</th><th>Sub</th><th>Flag</th><th>App</th><th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in payload.byDay" :key="row.eventDayId" @click="goToEncounters">
                    <td>{{ row.date | luxonShortDate }}</td>
                    <td>
                        <div class="bar">
                            <div class="seg seg-edit" :style="{ width: pct(row.editing, row.total) + '%' }" />
                            <div class="seg seg-sub" :style="{ width: pct(row.submitted, row.total) + '%' }" />
                            <div class="seg seg-flag" :style="{ width: pct(row.flagged, row.total) + '%' }" />
                            <div class="seg seg-app" :style="{ width: pct(row.approved, row.total) + '%' }" />
                        </div>
                    </td>
                    <td>{{ row.editing }}</td>
                    <td>{{ row.submitted }}</td>
                    <td>{{ row.flagged }}</td>
                    <td>{{ row.approved }}</td>
                    <td class="num">{{ row.total }}</td>
                </tr>
                <tr class="totals">
                    <td>All</td><td></td>
                    <td>{{ payload.totals.editing }}</td>
                    <td>{{ payload.totals.submitted }}</td>
                    <td>{{ payload.totals.flagged }}</td>
                    <td>{{ payload.totals.approved }}</td>
                    <td class="num">{{ payload.totals.total }}</td>
                </tr>
            </tbody>
        </table>
        <div class="legend">
            <span><i class="swatch seg-edit"></i>Editing</span>
            <span><i class="swatch seg-sub"></i>Submitted</span>
            <span><i class="swatch seg-flag"></i>Flagged</span>
            <span><i class="swatch seg-app"></i>Approved</span>
        </div>
        </div>
    </widget-card>
</template>

<script>
import api from '@/api'
import WidgetCard from './WidgetCard.vue'

export default {
    name: 'EncounterStatusWidget',
    components: { WidgetCard },
    props: {
        eventId: { type: Number, default: null },
        mode: { type: String, default: 'mine' },
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { loading: false, error: null, payload: null, hidden: false, inFlightKey: null }
    },
    watch: {
        eventId: { handler: 'fetchData', immediate: true },
        mode: 'fetchData',
        refreshKey: 'fetchData',
    },
    methods: {
        endpointUrl() {
            return `dashboard/encounters/${this.eventId}?mode=${this.normMode}`
        },
        async fetchData() {
            if (!this.eventId) { this.payload = null; return }
            const key = `${this.eventId}|${this.mode}`
            this.inFlightKey = key
            this.loading = true; this.error = null; this.hidden = false
            try {
                const data = await api.get(this.endpointUrl())
                if (this.inFlightKey !== key) return
                this.payload = data
            } catch (err) {
                if (this.inFlightKey !== key) return
                if (err.response && err.response.status === 403) { this.hidden = true; return }
                this.error = err
            } finally {
                if (this.inFlightKey === key) this.loading = false
            }
        },
        pct(part, total) {
            return total === 0 ? 0 : Math.round((part / total) * 100)
        },
        goToEncounters() {
            this.$router.push({ name: 'filterEncounter', params: { eventId: this.eventId } })
        },
    },
    computed: {
        normMode() { return this.mode.charAt(0).toUpperCase() + this.mode.slice(1) },
    },
}
</script>

<style scoped>
.enc-table { width: 100%; font-size: 12px; border-collapse: collapse; cursor: pointer; }
.enc-table th, .enc-table td { padding: 4px; text-align: left; border-bottom: 1px dotted #ddd; }
.enc-table th:first-child, .enc-table td:first-child { width: 1%; white-space: nowrap; }
.enc-table tr:hover td { background: rgba(25,118,210,0.04); }
.totals td { font-weight: 600; border-bottom: none; }
.bar { display: flex; height: 12px; border-radius: 2px; overflow: hidden; background: #eee; }
.seg-edit { background: #1976d2; }
.seg-sub  { background: #ffa000; }
.seg-flag { background: #d32f2f; }
.seg-app  { background: #4caf50; }
.legend { display: flex; gap: 12px; font-size: 11px; margin-top: 8px; color: rgba(0,0,0,0.7); }
.swatch { display: inline-block; width: 10px; height: 10px; border-radius: 2px; margin-right: 4px; vertical-align: middle; }
.num { font-weight: 600; color: #1976d2; }
.enc-wrap.is-dark .enc-table th, .enc-wrap.is-dark .enc-table td { border-bottom-color: rgba(255,255,255,0.18); }
.enc-wrap.is-dark .bar { background: rgba(255,255,255,0.12); }
.enc-wrap.is-dark .legend { color: rgba(255,255,255,0.85); }
</style>
